import React from 'react'
import TimeFormatter from '../../../utility/TimeFormatter';

const getMeetingTime = (date) => {
   if (!date) return;

   const userDate = TimeFormatter(date);
   let time_only = userDate.ShiftTime; 

   if (!time_only) return;

   const [time, period] = time_only.split(" "); 
   const [hour, minute] = time.split(":");   

   const formattedHour = hour.padStart(2, "0");

   return `${formattedHour}:${minute} ${period}`;
}

export default getMeetingTime;